import { FOUNDATION } from 'config/features';

export const MODULES = ['HEARTBEAT', 'ASSETS', 'GHOSTWRITER', 'PLATFORM'];

export const MODULE_PRIORITY = [
  {
    key: 'HEARTBEAT',
    path: FOUNDATION ? '/connect' : '/heartbeat',
  },
  {
    key: 'ASSETS',
    path: '/assets',
  },
  {
    key: 'GHOSTWRITER',
    path: '/ghostwriter',
  },
  {
    key: 'PLATFORM',
    path: '/platform',
  },
];
